import { render, staticRenderFns } from "./main.vue?vue&type=template&id=fca65ee2&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "../style.scss?vue&type=style&index=0&id=fca65ee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca65ee2",
  null
  
)

export default component.exports